import {intlShape, PlainTextOrHtml} from '@wallaby-ui/core';
import PropTypes from 'prop-types';
import * as React from 'react';
import {injectIntl} from 'react-intl';

import styles from './MarkerListFormatter.less';
import baseListFormatterItemParams from 'src/js/lib/raw_rendering/base_list_formatter_item_params';

class MarkerListFormatterItem extends React.PureComponent {
  render() {
    const {intl} = this.props;
    const {label, marker, title} = baseListFormatterItemParams(this.props, {
      intl,
    });
    return (
      <span className={styles.dlMarker} style={marker.style} title={title}>
        <PlainTextOrHtml text={label} showHtml />
      </span>
    );
  }
}

MarkerListFormatterItem.displayName = 'MarkerListFormatterItem';

/* eslint-disable react/no-unused-prop-types */
MarkerListFormatterItem.propTypes = {
  marker: PropTypes.objectOf(PropTypes.any),
  intl: intlShape.isRequired,
};

MarkerListFormatterItem.defaultProps = {
  marker: undefined,
};

export default injectIntl(MarkerListFormatterItem);
